import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import './App.css';

import Navbar from './components/Navbar';
import Home from './pages/Home';

const Education = lazy(() => import('./pages/Education'));
const Contact = lazy(() => import('./pages/Contact'));
const Interests = lazy(() => import('./pages/Interests'));
const Projects = lazy(() => import('./pages/Projects'));

const AGoodAlien = lazy(() => import('./pages/AGoodAlien'));
const KingsPath = lazy(() => import('./pages/KingsPath'));
const BalloonsOdyssey = lazy(() => import('./pages/BalloonsOdyssey'));

const BalloonsOdysseySkin01 = lazy(() => import('./pages/BalloonsOdyssey_Skin01'));
const BalloonsOdysseySkin02 = lazy(() => import('./pages/BalloonsOdyssey_Skin02'));
const BalloonsOdysseySkin03 = lazy(() => import('./pages/BalloonsOdyssey_Skin03'));

const BalloonsOdysseyAdvertisement = lazy(() => import('./pages/BalloonsOdyssey_Advertisement'));
const BalloonsOdysseySettings = lazy(() => import('./pages/BalloonsOdyssey_Settings'));
const BalloonsOdysseyTournament = lazy(() => import('./pages/BalloonsOdyssey_Tournament'));

const BalloonsOdysseyWorldGUI = lazy(() => import('./pages/BalloonsOdyssey_WorldGUI'));
const BalloonsOdysseyWorld01 = lazy(() => import('./pages/BalloonsOdyssey_World01'));
const BalloonsOdysseyWorld02 = lazy(() => import('./pages/BalloonsOdyssey_World02'));
const BalloonsOdysseyWorld03 = lazy(() => import('./pages/BalloonsOdyssey_World03'));
const BalloonsOdysseyWorld04 = lazy(() => import('./pages/BalloonsOdyssey_World04'));
const BalloonsOdysseyWorld05 = lazy(() => import('./pages/BalloonsOdyssey_World05'));

const BalloonsOdysseyStore01 = lazy(() => import('./pages/BalloonsOdyssey_Store01'));
const BalloonsOdysseyStore02 = lazy(() => import('./pages/BalloonsOdyssey_Store02'));
const BalloonsOdysseyStore03 = lazy(() => import('./pages/BalloonsOdyssey_Store03'));
const BalloonsOdysseyStore04 = lazy(() => import('./pages/BalloonsOdyssey_Store04'));
const BalloonsOdysseyStore05 = lazy(() => import('./pages/BalloonsOdyssey_Store05'));


function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Suspense fallback={<main className='page-content' />}>
          <Routes>
            {/* Navigation Bar routes. */}
            <Route path='/contact' element = {<Contact/>} />
            <Route path='/education' element = {<Education/>} />
            <Route path='/' element = {<Home/>} />
            <Route path='/interests' element = {<Interests/>} />
            <Route path='/projects' element = {<Projects/>} />

            {/* Cards routes. */}
            <Route path='/agoodalien' element = {<AGoodAlien/>} />
            <Route path='/kingspath' element = {<KingsPath/>} />
            <Route path='/balloonsodyssey' element = {<BalloonsOdyssey/>} />

            <Route path='/balloonsodyssey-advertisement' element = {<BalloonsOdysseyAdvertisement/>} />
            <Route path='/balloonsodyssey-settings' element = {<BalloonsOdysseySettings/>} />
            <Route path='/balloonsodyssey-tournament' element = {<BalloonsOdysseyTournament/>} />
            <Route path='/balloonsodyssey-worldGUI' element = {<BalloonsOdysseyWorldGUI/>} />

            <Route path='/balloonsodyssey-travelerskin' element = {<BalloonsOdysseySkin01/>} />
            <Route path='/balloonsodyssey-betaskin' element = {<BalloonsOdysseySkin02/>} />
            <Route path='/balloonsodyssey-wizardskin' element = {<BalloonsOdysseySkin03/>} />

            <Route path='/balloonsodyssey-world01' element = {<BalloonsOdysseyWorld01/>} />
            <Route path='/balloonsodyssey-world02' element = {<BalloonsOdysseyWorld02/>} />
            <Route path='/balloonsodyssey-world03' element = {<BalloonsOdysseyWorld03/>} />
            <Route path='/balloonsodyssey-world04' element = {<BalloonsOdysseyWorld04/>} />
            <Route path='/balloonsodyssey-world05' element = {<BalloonsOdysseyWorld05/>} />

            <Route path='/balloonsodyssey-store01' element = {<BalloonsOdysseyStore01/>} />
            <Route path='/balloonsodyssey-store02' element = {<BalloonsOdysseyStore02/>} />
            <Route path='/balloonsodyssey-store03' element = {<BalloonsOdysseyStore03/>} />
            <Route path='/balloonsodyssey-store04' element = {<BalloonsOdysseyStore04/>} />
            <Route path='/balloonsodyssey-store05' element = {<BalloonsOdysseyStore05/>} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
